import confirm from '../../../utils/confirm.jsx';
import { money } from '../../../utils/format';

export function request(id, { amount, paymentMethod }) {
    return confirm('Are you sure that you want to withdraw ' + money(amount) + '?', {
        type: 'CUSTOMERS_WITHDRAW_REQUEST',
        paymentMethod,
        amount,
        id
    });
}

export function error(id, errors) {
    return {
        type: 'CUSTOMERS_WITHDRAW_ERROR',
        errors,
        id
    };
}

export function form(id, data) {
    return {
        type: 'CUSTOMERS_WITHDRAW_FORM',
        data,
        id
    };
}

export function finish(id, { customer, transaction }) {
    return {
        type: 'CUSTOMERS_WITHDRAW_FINISH',
        transaction,
        customer,
        id
    };
}

export function clear(id) {
    return {
        type: 'CUSTOMERS_WITHDRAW_CLEAR',
        id
    };
}
